import styled from "styled-components";
import { useState, useEffect } from "react";

const StyledGrid2Groups = styled.div`
    position: relative;
    border: solid 1px ${(props) => props.theme.color.bordergray};
    ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    
    ::-webkit-scrollbar-track {
        background: ${(props) => props.theme.color.disabledgray};
        :disabled {
            background: #E0E0E0;
        }
    }
    
    ::-webkit-scrollbar-thumb {
        width: 10px;
        height: 10px;
        background-color: ${(props) => props.theme.color.gray};
    }
    
    ${({disabled}) => disabled && `
        background-color: lightgray;
        pointer-events: none;
    `}
`;

const GridHeaderRow = styled.div`
    display: flex;
    color: white;
    background-color: ${(props) => props.theme.color.primaryblue};
    border: none;
    height: 30px;
    box-sizing: border-box;
    border-bottom: solid 1px ${(props) => props.theme.color.disabledgray};

    > div {
        border-right: solid 1px ${(props) => props.theme.color.primaryhover};
    }

    div:last-child {
        border-right: none;
    }
`;

const GridHeaderCell = styled.div`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 12px;
    font-weight: 600;
    padding: 7px 10px;
    box-sizing: border-box;
    cursor: pointer;
    user-select: none;
    
    ${({order}) => order === 0 && `
    `}

    ${({order}) => order === 1 && `
        background: url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='12' height='12' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='white'/></g></svg>") no-repeat;
        background-position: right 5px top 60%;
    `}
    
    ${({order}) => order === 2 && `
        background: url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='12' height='12' transform='rotate(180)' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='white'/></g></svg>") no-repeat;
        background-position: right 5px top 60%;
    `}
`;

const GridRow = styled.div`
    display: flex;
    border: none;
    color: ${(props) => props.theme.color.gray};
    height: 21px;
    font-size: 12px;
    font-weight: 600;
    box-sizing: border-box;
    border-bottom: solid 1px ${(props) => props.theme.color.disabledgray};

    > div {
        border-right: solid 1px ${(props) => props.theme.color.disabledgray};
    }

    div:last-child {
        border-right: none;
    }
    
    ${({isSelected, disabled}) => isSelected && !disabled && `
        border-bottom: solid 1px #EB5A25;
        border-top: solid 1px #EB5A25;
        height: 22px;
        margin-top: -1px;
        
        > div {
            border-right: solid 1px #EB5A25;
        }

        div:last-child {
            border-right: solid 1px #EB5A25;
        }

        div:first-child {
            border-left: solid 1px #EB5A25;
        }
    `}
`;

const GridFilterCell = styled.div`
    font-size: 11px;
    font-weight: 600;
    padding: 0px 1px 0px 1px;
    box-sizing: border-box;
    cursor: pointer;
`;

const GridFilterCellInput = styled.input`
    box-sizing: border-box;
    padding-left: 0;
    font-size: 12px;
    font-weight: 400;
    padding-left: 25px;
    border: none;
    height: 21px;
    color: ${(props) => props.theme.color.gray};

    :focus {
        outline: none !important;
    }
    
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: ${(props) => props.theme.color.disabledgray};
        opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: ${(props) => props.theme.color.disabledgray};
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: ${(props) => props.theme.color.disabledgray};
    }
    
    background: transparent url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='lightgray' width='12' height='12' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E") no-repeat center;
    background-position: left 6px top 50%;
`;

const GridGroupRow1 = styled.div`
    display: flex;
    border: none;
    border-bottom: solid 1px ${(props) => props.theme.color.disabledgray};
    height: 20px;
    font-size: 10px;
    font-weight: 600;
    box-sizing: border-box;
    padding: 2px 10px;
    cursor: pointer;
    user-select: none;
    background: transparent url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='12' height='12' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='gray'/></g></svg>") no-repeat;
    background-position: right 10px top 50%;
    
    ${({showGroup}) => showGroup === true && `
        background: transparent url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='12' height='12' transform='rotate(90)' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='gray'/></g></svg>") no-repeat;
        background-position: right 10px top 50%;
    `}
    
    ${({showGroup}) => showGroup === false && `
        background: transparent url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='12' height='12' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='gray'/></g></svg>") no-repeat;
        background-position: right 10px top 50%;
    `}
    
    color: ${(props) => props.theme.color.gray};
    background-color: ${(props) => props.theme.color.disabledgray};
`;

const GridGroupRow2 = styled.div`
    display: flex;
    border: none;
    border-bottom: solid 1px ${(props) => props.theme.color.disabledgray};
    height: 20px;
    font-size: 10px;
    font-weight: 600;
    box-sizing: border-box;
    padding: 2px 10px;
    cursor: pointer;
    user-select: none;
    background: transparent url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='12' height='12' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='gray'/></g></svg>") no-repeat;
    background-position: right 10px top 50%;
    
    ${({showGroup}) => showGroup === true && `
        background: transparent url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='12' height='12' transform='rotate(90)' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='gray'/></g></svg>") no-repeat;
        background-position: right 10px top 50%;
    `}
    
    ${({showGroup}) => showGroup === false && `
        background: transparent url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='12' height='12' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='gray'/></g></svg>") no-repeat;
        background-position: right 10px top 50%;
    `}
    
    color: ${(props) => props.theme.color.dark};
    background-color: #E9E9E9;
`;

const GridCell = styled.div`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 10px;
    box-sizing: border-box;
    cursor: pointer;
    
    ${({isSelected, disabled}) => isSelected && !disabled && `
        background-color: #FDF2ED;
        color: #EB5A25;
    `}
`;

const GridContent = styled.div`
    overflow-y: scroll;
    height: calc(100% - 51px);

    ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    
    ::-webkit-scrollbar-track {
        background: ${(props) => props.theme.color.disabledgray};
        :disabled {
            background: #E0E0E0;
        }
    }
    
    ::-webkit-scrollbar-thumb {
        width: 10px;
        height: 10px;
        background-color: ${(props) => props.theme.color.gray};
    }
`;

function Grid2Groups(props) {

    const {id, gridColumns, gridData, itemIdToSelect, onSelectGridItem, gridStyle, fontSize, disabled, ...restProps} = props;

    const ORDER_NONE = 0;
    const ORDER_ASC = 1;
    const ORDER_DES = 2;
    const [isGroupShowing, setIsGroupShowing] = useState([]);
    const [columnOrder, setColumnOrder] = useState([]);
    const [columnSearchStrings, setColumnSearchStrings] = useState([]);
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [pageLoaded, setPageLoaded] = useState(false);

    const changeColumnOrder = (columnIndex) => {
        let orders = structuredClone(columnOrder);
        for (let i = 0; i < orders.length; i ++) {
            orders[i] = ORDER_NONE;
        }
        orders[columnIndex] = (columnOrder[columnIndex] + 1) % 3;
        setColumnOrder(orders);
    }

    const changeColumnSearchString = (e, columnIndex) => {
        let strs = structuredClone(columnSearchStrings);
        strs[columnIndex] = e.target.value;
        setColumnSearchStrings(strs);
    }

    const changeGroupShowing = (grpIdx) => {
        let shows = structuredClone(isGroupShowing);
        shows[grpIdx].show = !shows[grpIdx].show;
        setIsGroupShowing(shows);
    }

    const changeSubGroupShowing = (grpIdx, subGrpIdx) => {
        let shows = structuredClone(isGroupShowing);
        shows[grpIdx].showSubGroups[subGrpIdx] = !shows[grpIdx].showSubGroups[subGrpIdx];
        setIsGroupShowing(shows);
    }

    const selectItem = (item) => {
        setSelectedItemId(item.Id);
        onSelectGridItem(item);
    }

    const itemIsFoundOnSearch = (item) => {
        for (let i = 0; i < gridColumns.length; i ++) {
            if (gridColumns[i].type.toUpperCase() === 'BOOLEAN') {
                if (!boolToString(item[gridColumns[i].id]).toUpperCase().includes(columnSearchStrings[i].toUpperCase())) {
                    return false;
                }
            } else {
                if (!item[gridColumns[i].id].toUpperCase().includes(columnSearchStrings[i].toUpperCase())) {
                    return false;
                }
            }
        }
        return true;
    }

    const boolToString = (b) => {
        if (b === 1 || b === true) {
            return 'Yes';
        } else {
            return 'No';
        }
    }

    const sortItems = (a,b) => {
        for (let i = 0; i < columnOrder.length; i ++) {
            if (columnOrder[i] === ORDER_ASC) {
                if ( a[gridColumns[i].id] < b[gridColumns[i].id] ){
                    return -1;
                  }
                  if ( a[gridColumns[i].id] > b[gridColumns[i].id] ){
                    return 1;
                  }
                  return 0;
            }
            if (columnOrder[i] === ORDER_DES) {
                if ( a[gridColumns[i].id] < b[gridColumns[i].id] ){
                    return 1;
                  }
                  if ( a[gridColumns[i].id] > b[gridColumns[i].id] ){
                    return -1;
                  }
                  return 0;
            }
        }
    }

    useEffect(() => {
        if (!pageLoaded) {
            setPageLoaded(true);

            let sorts = [];
            gridColumns.map((col) => {
                sorts.push(ORDER_NONE);
            });
            setColumnOrder(sorts);

            let strs = [];
            gridColumns.map((col) => {
                strs.push('');
            });
            setColumnSearchStrings(strs);
            
            let groupShowing = [];
            gridData.groups.map((group) => {
                let subGroupShowing = [];
                group.subGroups.map((subGroup) => {
                    subGroupShowing.push(true);
                })
                groupShowing.push({show: true, showSubGroups: subGroupShowing});
            });
            setIsGroupShowing(groupShowing);
        }

        setSelectedItemId(itemIdToSelect);
        // if (itemIdToSelect) {
        //     for (let i = 0; i < gridData.groups.length; i ++) {
        //         for (let j = 0; j < gridData.groups[i].subGroups.length; j ++) {
        //             for (let k = 0; k < gridData.items[i][j].length; k ++) {
        //                 if (gridData.items[i][j][k].Id === itemIdToSelect) {
        //                     const itemRow = document.getElementById(id + '_row_' + gridData.items[i][j][k].Id);
        //                     if (itemRow) {
        //                         const gridComponent = itemRow.parentElement.parentElement;
                        
        //                         if (itemRow.offsetTop < gridComponent.scrollTop || itemRow.offsetTop > gridComponent.scrollTop + gridComponent.offsetHeight) {
        //                             let newScrollPos = itemRow.offsetTop - gridComponent.offsetHeight/2 + itemRow.offsetHeight/2;
        //                             gridComponent.scrollTop = newScrollPos;
        //                         }

        //                         onSelectGridItem(gridData.items[i][j][k]);
        //                         return;
        //                     }
        //                 }
        //             }
        //         }
        //     }
        // }
    }, [itemIdToSelect]);

    useEffect(() => {
        let groupShowing = [];
        gridData.groups.map((group) => {
            let subGroupShowing = [];
            group.subGroups.map((subGroup) => {
                subGroupShowing.push(true);
            })
            groupShowing.push({show: true, showSubGroups: subGroupShowing});
        });
        setIsGroupShowing(groupShowing);
    }, [gridData]);

    if (gridColumns.length > 0) {
        return (
            <StyledGrid2Groups id={id} disabled={disabled} style={{...gridStyle, width: gridStyle.width+10}}>
                <GridHeaderRow>
                    {gridColumns.map((col, colIdx) => {
                        return <GridHeaderCell key={colIdx} order={columnOrder[colIdx]} onClick={() => changeColumnOrder(colIdx)} style={{width: col.width}}>{col.id}</GridHeaderCell>
                    })}
                </GridHeaderRow>
                <GridRow disabled={disabled}>
                    {gridColumns.map((col, index) => {
                        return <GridFilterCell key={index} style={{width: col.width}}>
                            <GridFilterCellInput placeholder='Filter...' onChange={(e) => changeColumnSearchString(e, index)} style={{width: col.width-2}}></GridFilterCellInput>
                        </GridFilterCell>
                    })}
                </GridRow>
                <GridContent>
                {gridData.groups.map((group, grpIdx) => {
                    return <div key={'group-' + grpIdx}>
                    {gridData.groups.length>1 && <GridGroupRow1 key={grpIdx} showGroup={!!isGroupShowing[grpIdx] ? isGroupShowing[grpIdx].show : true} onClick={() => changeGroupShowing(grpIdx)}>{group.name}</GridGroupRow1>}
                        {(!!isGroupShowing[grpIdx] ? isGroupShowing[grpIdx].show : false) && group.subGroups.map((subGroup, subGrpIdx) => {
                            return <div key={'subgroup-' + subGrpIdx}>
                            <GridGroupRow2 key={subGrpIdx} showGroup={isGroupShowing[grpIdx].showSubGroups[subGrpIdx]} onClick={() => changeSubGroupShowing(grpIdx, subGrpIdx)}>{subGroup}</GridGroupRow2>
                            {isGroupShowing[grpIdx].showSubGroups[subGrpIdx] && [...gridData.items[grpIdx][subGrpIdx]].sort(sortItems).map((item, itmIdx) => {
                                return itemIsFoundOnSearch(item) ? <GridRow id={id+'_row_'+item.Id} disabled={disabled} key={item.Id} onClick={(e) => selectItem(item)} isSelected={selectedItemId === item.Id}>
                                    {gridColumns.map((col, colIdx) => {
                                        return <GridCell key={colIdx} disabled={disabled} isSelected={selectedItemId === item.Id} style={{width: col.width, textAlign: col.textAlign, fontSize: fontSize}}>
                                            {col.type.toUpperCase() === 'BOOLEAN' ? boolToString(item[col.id]) : item[col.id]}
                                        </GridCell>
                                    })}
                                </GridRow> : '';
                            })}
                            </div>
                        })}
                    </div>
                })}
                </GridContent>
            </StyledGrid2Groups>
        )
    } else {
        return <div></div>
    }
}

export default Grid2Groups;